const localStorageKey = {
  DEFAULT_CURRENCY: "current_currency",
  TOKEN: "token",
  USER_CURRENCY: "userCurrency",
  DEFAULT_LANG: "agentDefaultLang",
  REBATE_MODE: "rebate_mode",
};

export default localStorageKey;
